import { render } from "./OrderAttachments.vue?vue&type=template&id=da900998&scoped=true"
import script from "./OrderAttachments.vue?vue&type=script&lang=js"
export * from "./OrderAttachments.vue?vue&type=script&lang=js"

import "./OrderAttachments.vue?vue&type=style&index=0&id=da900998&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\projects\\external\\kazigraphix\\admin.kazigraphix\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da900998"]])

export default __exports__